import { useEffect, useState } from 'react'
import styles from './AdminCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import AdminCardMainInformation from '../../components/AdminCardMainInformation/AdminCardMainInformation'
// import AdminCardLoginDetails from '../../components/AdminCardLoginDetails/AdminCardLoginDetails'

import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { deleteAdmin, getCurrentAdmin } from '../../redux/actions/adminsAction'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../../components/UI/Loader/Loader'
import PATH from '../../navigation/path'

import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useMediaQuery } from 'react-responsive'
import { useToast } from '../../context/ToastContext'

const AdminCardPage = () => {
  const [visiblePopup, setVisiblePopup] = useState<boolean>(false)

  const { adminId } = useParams<{ adminId: string }>()

  const { isLoading, currentAdmin } = useAppSelector((state) => state.admins)
  const { token, user } = useAppSelector((state) => state.auth)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { showSuccess, showError } = useToast()
  // const onChangeSwipeCheckboxHandler = async (checked: boolean) => {
  //   const resultAction = await dispatch(
  //     blockAdmin({
  //       token,
  //       adminId: String(currentAdmin.id),
  //       isBlocked: !checked,
  //     }),
  //   )

  //   if (blockAdmin.rejected.match(resultAction)) {
  //     setAdminError(true)
  //     waitTimer(() => setAdminError(false))
  //   } else {
  //     setAdminError(false)
  //     await dispatch(getCurrentAdmin({ adminId, token }))
  //   }
  // }

  const onDeletePopup = () => {
    setVisiblePopup(true)
  }

  const onDeleteAdmin = async () => {
    const resultAction = await dispatch(deleteAdmin({ adminId, token }))

    if (deleteAdmin.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении')
    } else {
      navigate(PATH.administratorsManagementPage)
      showSuccess('Удаление админа прошло успешно')
    }
  }

  useEffect(() => {
    dispatch(getCurrentAdmin({ adminId, token }))
  }, [dispatch, adminId])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.adminCard}>
      <CustomModal visible={visiblePopup} setVisible={setVisiblePopup}>
        <DeleteComponent
          title='Удаление администратора'
          description='Хотите удалить данного администратора ?'
          onCancelHandler={() => setVisiblePopup(false)}
          onDeleteHandler={onDeleteAdmin}
        />
      </CustomModal>
      <Navbar />
      <div className={styles.container}>
        <HeaderForCard
          deleteButton={
            <CustomButton
              iconSrc={IconTrashRed}
              className={styles.btn}
              title={isMobile ? '' : 'Удалить администратора'}
              onClick={onDeletePopup}
            />
          }
          title='Карточка администратора'
        />
        <div className={styles.content}>
          <div>
            <AdminCardMainInformation adminData={currentAdmin} />
            {/* {currentAdmin.id != user.id && (
              <BlockAndDeletePanel
                buttonTitle='Сохранить'
                blockText='Администратор заблокирован'
                isBlocked={currentAdmin.isBlocked}
                checkBoxTitle='Заблокировать администратора'
                onChangeHandler={onChangeSwipeCheckboxHandler}
              />
            )} */}
          </div>
          {/* <AdminCardLoginDetails adminData={currentAdmin} /> */}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default AdminCardPage
